import { MNSproCloudApi } from '..';
import { FrontendMigrationResponse, FrontendMigrationStatus } from '../api/v2';

export class FrontendMigrationService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    return MNSproCloudApi.V2.FrontendMigrationApiFactory(config);
  }

  static async getMigrationStatus(
    authToken: string,
    organizationId: string,
  ): Promise<FrontendMigrationResponse> {
    const api = FrontendMigrationService.getApi(authToken);
    const response = await api.getFrontendMigrationStatus(organizationId);

    return response.data;
  }

  static async startMigration(
    authToken: string,
    organizationId: string,
  ): Promise<FrontendMigrationResponse> {
    const api = FrontendMigrationService.getApi(authToken);
    const response = await api.postStartFrontendMigration(organizationId);

    return response.data;
  }

  static async markMigrationFinished(
    authToken: string,
    organizationId: string,
  ): Promise<void> {
    const api = FrontendMigrationService.getApi(authToken);
    await api.updateStatus(organizationId, FrontendMigrationStatus.success);
  }
}
